import { Component, OnInit, TemplateRef } from "@angular/core";
import { BsModalService, BsModalRef, ModalOptions } from "ngx-bootstrap/modal";
import { StorageService } from "src/app/features/http-services/storage.service";
import { ProductService } from "src/app/features/residential/products/services/product.service";
import { OrderService } from "src/app/features/residential/orders/services/order.service"; 
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: 'xchange-create-reserve-modal',
  templateUrl: './create-reserve-modal.component.html',
  styleUrl: './create-reserve-modal.component.scss'
})
export class CreateReserveModalComponent {
  modalRef!: BsModalRef;
  reserveNumber: any;
  modalForm!: FormGroup;
  cartNumberData: any = {};
  cartEntries = [];
  spinnerLoading = false;
  getCartAction = (d:any) => {};

  constructor(
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private productService: ProductService,
    private getStorageService: StorageService,
    private orderService: OrderService,
    private route: ActivatedRoute,
    private router: Router,
    private fb : FormBuilder
  ) {
    this.getStorageService.getItem("miniCartCount").subscribe((res) => {
      this.cartNumberData = res;
    });
  }

  public data = [];

  ngOnInit(): void {
    this.modalForm = this.fb.group({
      reserveName: [ "",
        [Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]*$/)]],
    });

    this.reserveNumber = this.route.snapshot.paramMap.get("id");

    this.productService
      .getCartData(this.getStorageService?.cartData?.code)
      .subscribe({
        next: (res: any) => {
          if (res && res.body) {
            this.cartEntries = res.body.entries ? res.body.entries : [];
          }
        },
      });
  }
  reserveNumberDetailing: any = [];

  doneReserve() {
    this.spinnerLoading = true;
    this.productService
      .placeReserve(this.cartNumberData?.code, this.modalForm.value.reserveName)
      .subscribe({
        next: (res) => {
          this.spinnerLoading = false;
          let data = res?.body;
          this.getCartAction(data);
          this.modalService.hide();
        },
        error: (err) => {
          this.modalService.hide();
        },
      });
  }

  cancelReserve() {
    this.modalService.hide();
  }

}
